import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalWindowComponent} from "../../std-components/modal-window/modal-window.component";
import {BuildingFloor, BuildingOtherRooms, ISpot, RoomTypeItem} from "../../shared/models/models";
import {ServerService} from "../../shared/services/server.service";
import {SpotFormEditorComponent} from "../spot-form-editor/spot-form-editor.component";
import {ToastrService} from 'ngx-toastr';

import {EventService} from '../../shared/services/event.service';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'app-add-appartment',
    templateUrl: './add-appartment.component.html',
    styleUrls: ['./add-appartment.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ModalWindowComponent]
})
export class AddAppartmentComponent implements OnInit {

    @Input() spotObjectAddAppartments: ISpot;
    @Output() outputCompleteSpot = new EventEmitter<ISpot>();
    @Input() floorsCommercial: boolean;
    @Input() countOfOpen: number;
    @Input() changeAppartment: number | any;




    onchangeModel = false;
    countRoomsOfFloor: number[][] = [];
    countRoomsOfFloorModel: number[][] = [];
    countRooms: number = 0;
    auxiliaryPremisesTypes: RoomTypeItem[] = [];
    commercialPremisesTypes: RoomTypeItem[] = [];
    parkingTypes: RoomTypeItem[] = [];
    mansardRoom: RoomTypeItem = null;
    buildingOtherRooms: BuildingOtherRooms = null;
    buildingOtherRoomsSet: BuildingOtherRooms[] = [];


    constructor(private modalWindow: ModalWindowComponent,
        private serverService: ServerService,
        private spotForm: SpotFormEditorComponent,
        private event: EventService,
        public toastr: ToastrService) { }

    ngOnInit() {

        this.countRooms = this.spotObjectAddAppartments.countRooms.length;
        this.buildingOtherRooms = {
            BuildingID: this.spotObjectAddAppartments.id,
            Delete: false,
            Area: 0,
            RoomTypeItemID: null,
            PlaceCount: 0,
            PhotoFileID: 0
        };

        this.copyCountFlatOfRooms();

        this.cloneOtherRooms(this.spotObjectAddAppartments.commercialRooms, this.commercialPremisesTypes);
        this.cloneOtherRooms(this.spotObjectAddAppartments.auxiliaryRooms, this.auxiliaryPremisesTypes);
        this.cloneOtherRooms(this.spotObjectAddAppartments.parkingRooms, this.parkingTypes);

        if (this.spotObjectAddAppartments.mansardRooms) {
            this.mansardRoom = Object.assign({}, this.spotObjectAddAppartments.mansardRooms);
        }

    }

    copyCountFlatOfRooms() {

        if (this.countOfOpen === 0 || this.changeAppartment) {
            this.spotObjectAddAppartments.countRoomsOfFloor = this.spotObjectAddAppartments.countRoomsOfFloor.reverse();
        }


        for (let i = 0; i < this.spotObjectAddAppartments.floors; i++) {
            this.countRoomsOfFloor.push(new Array(this.countRooms));
            this.countRoomsOfFloorModel.push(new Array(this.countRooms));
            for (let j = 0; j < this.countRooms; j++) {
                if (this.spotObjectAddAppartments.countRoomsOfFloor.length && this.spotObjectAddAppartments.countRoomsOfFloor[i][j] === 0) {
                    this.spotObjectAddAppartments.countRoomsOfFloor[i][j] = null;
                }
                if (this.spotObjectAddAppartments.countRoomsOfFloor.length) {
                  this.countRoomsOfFloor[i][j] = this.spotObjectAddAppartments.countRoomsOfFloor[i][j];
                  this.countRoomsOfFloorModel[i][j] = this.spotObjectAddAppartments.countRoomsOfFloor[i][j];
                }
            }
        }

        let countRoomOfFloor = this.countRoomsOfFloor.length;


        //TODO
        this.spotObjectAddAppartments.commercialRooms.forEach(element => {
            if (element.checked === true) {
                if (element.id === 10101 || element.id === 10301) {
                    this.countRoomsOfFloor.splice(countRoomOfFloor - 1, 1);
                    this.countRoomsOfFloorModel.splice(countRoomOfFloor - 1, 1);
                }
                if (element.id === 10102 || element.id === 10302) {
                    this.countRoomsOfFloor.splice(countRoomOfFloor - 2, 1);
                    this.countRoomsOfFloorModel.splice(countRoomOfFloor - 2, 1);

                }
            }
        });

        //TODO
        this.spotObjectAddAppartments.parkingRooms.forEach(element => {
            if (element.checked === true) {
                if (element.id === 30401) {
                    this.countRoomsOfFloor.splice(countRoomOfFloor - 1, 1);
                    this.countRoomsOfFloorModel.splice(countRoomOfFloor - 1, 1);
                }
                if (element.id === 30402) {
                    this.countRoomsOfFloor.splice(countRoomOfFloor - 2, 1);
                    this.countRoomsOfFloorModel.splice(countRoomOfFloor - 2, 1);

                }
            }
        });
    }

    cloneOtherRooms(otherRoom: RoomTypeItem[], clone: RoomTypeItem[]) {
        for (let rooms of otherRoom) {
            if (rooms.checked)
                clone.push(Object.assign({}, rooms));
        }
    }

    annulVariables() {
        this.countRoomsOfFloor = [];
        this.parkingTypes = [];
        this.auxiliaryPremisesTypes = [];
        this.commercialPremisesTypes = [];
        this.mansardRoom = null;
        this.buildingOtherRooms = null;
        this.buildingOtherRoomsSet = [];
        this.countRooms = 0;
    }

    trackByIdx(index: number): any {
        return index;
    }

    closeModalWindow() {
        this.annulVariables();
        this.modalWindow.closeModalWindow();
    }

    changedModel() {
        this.onchangeModel = true;
    }

    changedCountOfFloors(i: number, j: number) {
        if (this.countRoomsOfFloor[i][j] < this.countRoomsOfFloorModel[i][j]) {
            this.changes = true;
        } else {
            this.onchangeModel = true;
        }
    }

    changes = false;

    acceptChanges() {
        this.countRoomsOfFloor = this.countRoomsOfFloorModel;
        this.changes = false;
    }

    cancelChanges() {
        this.changes = false;
        this.closeModalWindow();

    }

    saveState() {

        let i: number = 0, j: number = 0, max_value: number = 0, count: number = 0, last_index: number = 0;
        this.spotObjectAddAppartments.countRooms.forEach(function (value) {
            if (value.flatCount !== null)
                value.flatCount = 0;
        });

        let buildingFloors: BuildingFloor[] = [];
        let buildingFloor: BuildingFloor = { buildingID: null, floorID: null, roomCountID: null, flatCount: null };


        for (i = 0; i < this.spotObjectAddAppartments.apartmentCount.length; i++) {
            for (j = 0; j < this.countRooms; j++) {
                if (this.countRoomsOfFloor[i][j] != this.spotObjectAddAppartments.countRoomsOfFloor[i][j]) {
                    this.spotObjectAddAppartments.apartment_number += this.countRoomsOfFloor[i][j] - this.spotObjectAddAppartments.countRoomsOfFloor[i][j];
                    this.spotObjectAddAppartments.residueFlatCount += this.countRoomsOfFloor[i][j] - this.spotObjectAddAppartments.countRoomsOfFloor[i][j];
                    let new_floor = Object.assign({}, buildingFloor);
                    new_floor.buildingID = this.spotObjectAddAppartments.id;
                    new_floor.floorID = this.spotObjectAddAppartments.apartmentCount[i].floorID;
                    new_floor.roomCountID = this.spotObjectAddAppartments.countRooms[j].roomCountID;
                    new_floor.flatCount = this.countRoomsOfFloor[i][j];
                    buildingFloors.push(new_floor);
                }
            }
        }

        //update changed building other rooms;
        this.updateBuildingOtherRooms(this.spotObjectAddAppartments.commercialRooms, this.commercialPremisesTypes);
        this.updateBuildingOtherRooms(this.spotObjectAddAppartments.auxiliaryRooms, this.auxiliaryPremisesTypes);
        this.updateBuildingOtherRooms(this.spotObjectAddAppartments.parkingRooms, this.parkingTypes);

        if (this.spotObjectAddAppartments.hasMansard) {
            this.spotObjectAddAppartments.mansardRooms.area = this.mansardRoom.area;
            this.spotObjectAddAppartments.mansardRooms.placeCount = this.mansardRoom.placeCount;

            this.buildingOtherRooms.RoomTypeItemID = this.mansardRoom.id;
            this.buildingOtherRooms.Area = this.mansardRoom.area;
            this.buildingOtherRooms.Delete = !this.mansardRoom.checked;
            this.buildingOtherRooms.PlaceCount = this.mansardRoom.placeCount;

            this.buildingOtherRoomsSet.push(Object.assign({}, this.buildingOtherRooms));
        }
        this.setOtherRooms(this.buildingOtherRoomsSet);

        this.spotForm.loader = true;

        this.serverService.setBuildingFloor(buildingFloors.reverse()).then(res => {


            this.event.sendChanges(true);
            this.spotForm.initializeSpotScheme(this.spotObjectAddAppartments);
            this.toastr.success('Изменения сохранены!', 'Успешно!');



        }, (err: any) => {
            if (err.status == 400) {
                alert("Ошибка в добавлении количество квартир по комнатам в этажах");
            }
            if (err.status == 500 || err.status == 0) {
                this.toastr.error('К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позже!', 'Ваши данные не сохранены!');
            }
        });
        this.closeModalWindow();
    }

    updateBuildingOtherRooms(otherRoom: RoomTypeItem[], cloneOtherRoom: RoomTypeItem[]) {
        let i = 0;
        // for (let rooms of cloneOtherRoom) {
        //     otherRoom[i].area = rooms.area;
        //     otherRoom[i].placeCount = rooms.placeCount;
        //     console.log(otherRoom[i]);
        //     console.log(rooms);

        //     this.buildingOtherRooms.RoomTypeItemID = rooms.id;
        //     this.buildingOtherRooms.Area = rooms.area;
        //     this.buildingOtherRooms.Delete = !rooms.checked;
        //     this.buildingOtherRooms.PlaceCount = rooms.placeCount;

        //     this.buildingOtherRoomsSet.push(Object.assign({}, this.buildingOtherRooms));
        //     i++;
        // }
        for (let i = 0; i < otherRoom.length; i++) {
            for (let j = 0; j < cloneOtherRoom.length; j++) {
                if (otherRoom[i].id === cloneOtherRoom[j].id) {
                    otherRoom[i] = cloneOtherRoom[j];

                    this.buildingOtherRooms.RoomTypeItemID = cloneOtherRoom[j].id;
                    this.buildingOtherRooms.Area = cloneOtherRoom[j].area;
                    this.buildingOtherRooms.Delete = !cloneOtherRoom[j].checked;
                    this.buildingOtherRooms.PlaceCount = cloneOtherRoom[j].placeCount;

                    this.buildingOtherRoomsSet.push(Object.assign({}, this.buildingOtherRooms));
                }
            }
        }
    }

    setOtherRooms(buildingRoom) {
        this.serverService.setBuildingOtherRoomsWf(buildingRoom).then(res => {
            this.annulVariables();
        }, (err: any) => {
            alert("Ошибка в добавлении помещения");
        });
    }
}
